import { render, staticRenderFns } from "./OrganizationInfoItemList.vue?vue&type=template&id=6563b65e&scoped=true&"
import script from "./OrganizationInfoItemList.vue?vue&type=script&lang=js&"
export * from "./OrganizationInfoItemList.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationInfoItemList.vue?vue&type=style&index=0&id=6563b65e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6563b65e",
  null
  
)

export default component.exports